import Util                        from "../../utils/Util"
import AttributeQuestionValue      from "./AttributeQuestionValue"
import AttributeColorValue         from "./AttributeColorValue"
import AttributeMaterialGroupValue from "./AttributeMaterialGroupValue"
import AttributeValue              from "./AttributeValue"

export default class AttributeValueFactory {

    /**
     * Factory function that returns one of the derived classes, according to the valuable type.
     * @param data
     */
    static create(data) {
        if (Util.hasNestedProperty(data, 'valuable_type')) {
            let valuableType = Util.getNestedProperty(data, 'valuable_type')

            switch (valuableType) {
                case 'App\\Models\\AttributeQuestionValue':
                    return new AttributeQuestionValue(data)
                case 'App\\Models\\AttributeColorValue':
                    return new AttributeColorValue(data)
                case 'App\\Models\\AttributeMaterialGroupValue':
                    return new AttributeMaterialGroupValue(data)
                default:
                    return new AttributeValue(data)
            }
        }
    }
}
